module.exports = __webpack_public_path__ + "static/media/me-polaroid.05c5f648.jpg";